import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, withStyles } from '@material-ui/styles';
import { Typography, Link, Grid, useMediaQuery, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Button } from '@lc/legacy/src/Components';

import { booking } from 'helpers';
import PeriodList from './PeriodList';

const MyPeriodSelection = ({
  data,
  setShowMyPeriodsPrice,
  PeriodDaySelector,
  setEditingPeriodDay,
  editingPeriodDay,
  activeStep,
  setActiveStep,
  itemsAvailability,
  checkeds,
  setChecked,
  onClose,
  hidePeriod,
  mySelections,
  onSelectMore,
}) => {
  const { t } = useTranslation(['booking']);
  const theme = useTheme();
  const xsSize = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div style={{ marginTop: '20px' }}>
      {editingPeriodDay && (
        <>
          <PeriodDaySelector />
          <Grid
            container
            spacing={0}
            justify="space-between"
            style={{ marginTop: '14px', alignItems: 'center' }}
          >
            <Grid item xs={12} lg={6} style={{ marginBottom: xsSize ? '24px' : '' }}>
              <Link
                color="primary"
                underline="always"
                href="#/"
                onClick={() => {
                  const { ...selectedPeriods } = checkeds;
                  Object.keys(selectedPeriods).forEach(item => {
                    const date = item.split('@')[0];
                    if (itemsAvailability[activeStep][0] === date) {
                      selectedPeriods[item] = false;
                    }
                  });
                  setChecked(selectedPeriods);
                  const periods = booking.getPeriods(data.id);
                  delete periods[itemsAvailability[activeStep][0]];
                  booking.setPeriods(data.id, periods);
                }}
                style={{ textTransform: 'initial', fontSize: xsSize ? '10px' : '12px' }}
              >
                Limpar os períodos
              </Link>
            </Grid>
            <Grid
              container
              spacing={0}
              justify={xsSize ? 'space-between' : 'flex-end'}
              item
              xs={12}
              lg={6}
            >
              <Button
                size={xsSize ? 'xs' : ''}
                color="secondary"
                variant="outlined"
                onClick={() => {onSelectMore(); window.scrollTo(0, 0);}}
              >
                {t('chooseMorePeriods')}
              </Button>
              {!xsSize ? <Box ml={2} /> : null}

              <Button
                size={xsSize ? 'xs' : ''}
                color="secondary"
                variant="contained"
                disabled={!mySelections}
                onClick={() => onClose()}
              >
                Prosseguir
              </Button>
            </Grid>
          </Grid>
        </>
      )}
      {!editingPeriodDay && (
        <>
          <PeriodList
            items={booking.getPeriods(data.id)}
            selectedDay={d => {
              setEditingPeriodDay(true);
              setActiveStep(itemsAvailability.findIndex(idx => idx[0] === d));
            }}
            period_hours={data.period_hours}
          />
          {!hidePeriod && (
            <Button onClick={() => setShowMyPeriodsPrice(true)} size="xs" style={{ padding: 0 }}>
              <img src="/images/icons/dollar.png" alt="dollar" />
              <Typography variant="overline" color="textSecondary" style={{ marginLeft: '5px' }}>
                {t('myPeriods')}
              </Typography>
            </Button>
          )}
        </>
      )}
    </div>
  );
};

MyPeriodSelection.propTypes = {
  activeStep: PropTypes.number.isRequired,
  checkeds: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  editingPeriodDay: PropTypes.bool.isRequired,
  hidePeriod: PropTypes.bool,
  itemsAvailability: PropTypes.array.isRequired,
  mySelections: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectMore: PropTypes.func.isRequired,
  PeriodDaySelector: PropTypes.any.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  setChecked: PropTypes.func.isRequired,
  setEditingPeriodDay: PropTypes.func.isRequired,
  setShowMyPeriodsPrice: PropTypes.func.isRequired,
};

MyPeriodSelection.defaultProps = {
  hidePeriod: false,
};

const styles = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  container: {
    borderRadius: '4px',
    border: '0.7px solid #797979',
    margin: 5,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    justifyContent: 'space-between',
    height: '55px',
  },
  button: {
    color: theme.palette.secondary.main,
    minWidth: 0,
    padding: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '160px',
  },
  contentItem: {
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 5,
  },
  label: {
    fontWeight: 'bold',
  },
});

export default withStyles(styles)(MyPeriodSelection);
